import { Patch } from "..";
import { Instruction, Code, Register } from '@geeki/iced-x86';

export default [
    {
        name: "启用 LDJ 模式",
        patches: [{ offset: 0x97CB57, off: [0x03], on: [0x02] }],
    },
    {
        name: "在 LDJ 模式下使用自定义帧数",
        patches: [
            { offset: 0x76AF13, off: [0x75], on: [0xEB] },
            { offset: 0x97CAA7, off: [0x74, 0x03], on: [0x90, 0x90] },
        ]
    },
    {
        type: "union",
        name: "选择自定义的帧数",
        tooltip: "如高刷显示器不支持 120Hz, 请使用 CRU 或 NVIDIA 控制面板增加一个自定义的 120Hz 的分辨率, 通常来说这些高刷显示器支持 120Hz 是完全没有问题的。",
        offset: 0x97C891,
        patches: [
            {
                name: "60 FPS",
                patch: [0xC7, 0x45, 0xDB, 0x3C, 0x00, 0x00, 0x00, 0xC7, 0x45, 0xFF, 0x01, 0x00, 0x00, 0x00, 0x48, 0x8B, 0x45, 0xD7, 0x48, 0x89, 0x45, 0x03, 0xC7, 0x45, 0xD7, 0x01, 0x00, 0x00, 0x00, 0xC7, 0x45, 0xDB, 0x3C, 0x00, 0x00, 0x00],
            },
            {
                name: "120 FPS",
                patch: [0xC7, 0x45, 0xDB, 0x78, 0x00, 0x00, 0x00, 0xC7, 0x45, 0xFF, 0x01, 0x00, 0x00, 0x00, 0x48, 0x8B, 0x45, 0xD7, 0x48, 0x89, 0x45, 0x03, 0xC7, 0x45, 0xD7, 0x01, 0x00, 0x00, 0x00, 0xC7, 0x45, 0xDB, 0x78, 0x00, 0x00, 0x00],
            },
        ],
    },
    {
        name: '-',
        type: 'splitter',
    },
    {
        type: "union",
        name: "选择显示器检测目标 FPS",
        tooltip: "如高刷显示器不支持 120Hz, 请使用 CRU 或 NVIDIA 控制面板增加一个自定义的 120Hz 的分辨率, 通常来说这些高刷显示器支持 120Hz 是完全没有问题的。",
        offset: 0x87D9B6,
        patches: [
            {
                name: "60 FPS",
                patch: [0x3C, 0x00],
            },
            {
                name: "120 FPS",
                patch: [0x78, 0x00],
            },
        ]
    },
    {
        name: "旧版显示器检测逻辑 (禁用重试)",
        tooltip: "会加快显示器检测速度。如使用 60FPS 请勾选, 否则就算没问题也会 MONITOR ERROR",
        patches: [
            { offset: 0x875F31, on: [0xE9, 0xA7, 0x00, 0x00, 0x00, 0x90], off: [0x0F, 0x8C, 0xA6, 0x00, 0x00, 0x00] },
            { offset: 0x876029, on: [0xEB], off: [0x7D] }
        ]
    },
    {
        name: "跳过显示器检测",
        patches: [
            { offset: 0x875FEA, off: [0x8C], on: [0x8D] },
            { offset: 0x87604A, off: [0x77, 0x0E], on: [0x90, 0x90] },
            { offset: 0x876054, off: [0x0F, 0x86, 0x8B, 0x00, 0x00, 0x00], on: [0xE9, 0x8C, 0x00, 0x00, 0x00, 0x90] },
        ],
    },
    {
        type: "union",
        name: "跳过显示器检测 FPS",
        offset: 0x88AB40,
        patches: [
            {
                name: "不修改",
                patch: [0x44, 0x8B, 0x91, 0x70, 0x0B, 0x00, 0x00, 0x44, 0x8B, 0xCA, 0x4C, 0x8B, 0xD9, 0x41, 0x81, 0xC2, 0x67, 0x01, 0x00, 0x00],
            },
            {
                name: "60.0000 FPS",
                patch: [0x48, 0xB8, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x4E, 0x40, 0x66, 0x48, 0x0F, 0x6E, 0xC0, 0xF2, 0x0F, 0x58, 0xC8, 0xC3],
            },
            {
                name: "120.0000 FPS",
                patch: [0x48, 0xB8, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x5E, 0x40, 0x66, 0x48, 0x0F, 0x6E, 0xC0, 0xF2, 0x0F, 0x58, 0xC8, 0xC3],
            },
        ],
    },
    {
        name: '-',
        type: 'splitter',
    },
    {
        type: "union",
        name: "选择音频输出模式",
        tooltip: "游戏不吃 SOUND_OUTPUT_DEVICE 环境变量了, spice 也拿他没办法",
        offset: 0x9AF133,
        patches: [
            {
                name: "不修改",
                patch: [0xE8, 0xC8, 0xE2, 0xEC, 0xFF, 0x83, 0x78, 0x08, 0x03],
            },
            {
                name: "WASAPI",
                patch: [0xBB, 0x00, 0x00, 0x00, 0x00, 0xEB, 0x16, 0x90, 0x90],
            },
            {
                name: "ASIO",
                patch: [0xBB, 0x01, 0x00, 0x00, 0x00, 0xEB, 0x16, 0x90, 0x90],
            },
        ]
    },
    {
        name: "启用 WASAPI 共享模式",
        tooltip: "推荐使用 Windows 自带声卡驱动并且在 spice2x 内启用 -sp2x-lowlatencysharedaudio",
        patches: [{ offset: 0x463D6B, off: [0x44, 0x8B, 0xF2], on: [0x4D, 0x31, 0xF6] }],
    },
    {
        name: "阻止调整系统音量",
        tooltip: "spice2x 现在自带这个功能了快去更新吧",
        type: "tooltip",
    },
    {
        name: "最大游戏音量",
        tooltip: "忽略游戏内音量设置转而使用最大音量, 适用于声音很轻的情况。当你想要使用 TDJ 自带的耳机音量调节时请勿开启。",
        patches: [{ offset: 0x99E625, off: [0xFF, 0x90, 0x98, 0x00, 0x00, 0x00, 0x90], on: [0x90, 0x90, 0x90, 0x90, 0x90, 0x90, 0x90] }],
    },
    {
        name: "启用 BMSoundLib 日志输出",
        tooltip: '游戏启动不了时可以用这个进行除错',
        patches: [{
            offset: 0x39BE51,
            /*
             * lea     rcx, aBmsoundlib ; "BMSoundLib"
             * jmp     cs:avs2_log_warn
             */
            on: [
                0x8D, 0x0D, 0xE1, 0xB6, 0x94, 0x00, 0xFF, 0x25, 0xCB, 0x03, 0x7E, 0x00, 0x90, 0x90,
            ],
            off: [
                0x89, 0x54, 0x24, 0x10, 0x4C, 0x89, 0x44, 0x24, 0x18, 0x4C, 0x89, 0x4C, 0x24, 0x20,
            ]
        }],
    },
    {
        name: '-',
        type: 'splitter',
    },
    {
        name: '启用 Premium Free',
        tooltip: "到底是谁在教人开 FreePlay.jpg<br>关掉就有了",
        type: "tooltip",
    },
    {
        name: "PF 倒计时冻结",
        patches: [{ offset: 0x7EEA5D, off: [0x7E], on: [0xEB] }],
    },
    {
        name: "PF 倒计时显示时间 (UTC+8)",
        patches: [{ offset: 0x7EEA70, off: [
            0x8B, 0x4B, 0x0C, 0x4C, 0x8B, 0xC0, 0x48, 0xB8, 0x77, 0xBE, 0x9F, 0x1A, 0x2F, 0xDD, 0x24, 0x06,
            0x49, 0xF7, 0xE0, 0x33, 0xC0, 0x4C, 0x2B, 0xC2, 0x49, 0xD1, 0xE8, 0x4C, 0x03, 0xC2, 0x49, 0xC1,
            0xE8, 0x09,
        ], on: [
            0x31, 0xD2, 0xB9, 0x60, 0xEA, 0x00, 0x00, 0x48, 0xF7, 0xF1, 0x31, 0xD2, 0xB9, 0xA0, 0x05, 0x00,
            0x00, 0x48, 0xF7, 0xF1, 0x48, 0x89, 0xD0, 0x48, 0x05, 0xE0, 0x01, 0x00, 0x00, 0x89, 0x43, 0x14,
            0xEB, 0x0B,
        ] }],
    },
    {
        name: "菜单倒计时倒涨",
        tooltip: "倒计时变正计时",
        patches: [{ 
            offset: 0x8ACCAE, 
            off: [0x8B], 
            on: [0x83] 
        }],
    },
    {
        name: "选曲游标锁定",
        patches: [{ offset: 0x83791C, off: [0x74, 0x21], on: [0x90, 0x90] }],
    },
    {
        name: "开始时按住 START 一直暂停歌曲",
        patches: [{ offset: 0x858827, off: [0x7D, 0x36], on: [0x90, 0x90] }],
    },
    {
        type: 'asm',
        name: "更快的快速重试",
        tooltip: "缩短 'STAGE FAILED' 动画的长度.",
        arch: 'x86-64',
        patches: [{
            offset: 0x857CD5,
            va: 0x180A77233,
            on: [
                Instruction.create(Code.Nopd),
                Instruction.create(Code.Nopd),
            ],
            off: [
                Instruction.createBranch(Code.Jl_rel8_64, 0x180A77233n + 0x14n),
            ]
        }],
    },
    {
        type: 'asm',
        name: '游玩黑谱不消耗 V-Disc',
        tooltip: '可无限玩黑谱',
        arch: 'x86-64',
        patches: [{
            offset: 0x5820F0,
            va: 0x180582CF0,
            on: [
                Instruction.create(Code.Retnq),
                Instruction.create(Code.Nopd),
                Instruction.create(Code.Nopd),
            ],
            off: [
                Instruction.createRegReg(Code.Test_rm64_r64, Register.R8, Register.R8),
            ]
        }]
    },
    {
        name: "Auto Play",
        tooltip: "DJ AUTOPLAY 上号!",
        patches: [{ offset: 0x79CA19, off: [0x00], on: [0x01] }],
    },
    {
        name: '-',
        type: 'splitter',
    },
    {
        name: "歌曲全解",
        patches: [{ offset: 0x7E875A, off: [0x32, 0xC0], on: [0xB0, 0x01] }],
    },
    {
        name: "解锁所有副屏自定义",
        patches: [{
            offset: 0x9DB3F0,
            /*
             * mov     ebx, 0
             * cmp     ebx, 0Eh
             * jge     0x1809DC370
             * mov     rax, [rsp+40h]
             * mov     rax, [rax+0F8h]
             * movsxd  rdx, ebx
             * shl     rdx, 3
             * add     rax, rdx
             * mov     qword ptr [rax], 0FFFFFFFFFFFFFFFFh
             * add     ebx, 1
             * jmp     short 0x1809DBFF8
             */
            on: [
                0xFE, 0xFF, 0xFF, 0xBB, 0x00, 0x00, 0x00, 0x00, 0x83, 0xFB, 0x0E, 0x0F, 0x8D, 0x6F, 0x03, 0x00,
                0x00, 0x48, 0x8B, 0x44, 0x24, 0x40, 0x48, 0x8B, 0x80, 0xF8, 0x00, 0x00, 0x00, 0x48, 0x63, 0xD3,
                0x48, 0xC1, 0xE2, 0x03, 0x48, 0x01, 0xD0, 0x48, 0xC7, 0x00, 0xFF, 0xFF, 0xFF, 0xFF, 0x83, 0xC3,
                0x01, 0xEB, 0xD5, 0x48, 0x8B, 0x80, 0xF8, 0x00, 0x00, 0x00, 0x48, 0x89, 0x44, 0x24, 0x20, 0x4C,
            ],
            off: [
                0xFE, 0xFF, 0xFF, 0x4C, 0x8D, 0x05, 0x3E, 0x6F, 0x31, 0x00, 0x48, 0x8B, 0x94, 0x24, 0xA8, 0x04,
                0x00, 0x00, 0x48, 0x8B, 0x4C, 0x24, 0x38, 0xFF, 0x15, 0xFB, 0x0E, 0x1A, 0x00, 0x48, 0x89, 0x44,
                0x24, 0x48, 0x48, 0x83, 0x7C, 0x24, 0x48, 0x00, 0x0F, 0x84, 0x52, 0x03, 0x00, 0x00, 0x48, 0x8B,
                0x44, 0x24, 0x40, 0x48, 0x8B, 0x80, 0xF8, 0x00, 0x00, 0x00, 0x48, 0x89, 0x44, 0x24, 0x20, 0x4C,
            ],
        }]
    },
    {
        name: "解锁所有副屏主题",
        patches: [{
            offset: 0x9DB770,
            /*
             * mov     rax, [rsp+40h]
             * mov     rax, [rax+100h]
             * mov     qword ptr [rax], 0FFFFFFFFFFFFFFFFh
             * mov     qword ptr [rax+8], 0FFFFFFFFFFFFFFFFh
             * jmp     0x1809DC41C
             */
            on: [
                0x48, 0x8B, 0x44, 0x24, 0x40, 0x48, 0x8B, 0x80, 0x00, 0x01, 0x00, 0x00, 0x48, 0xC7, 0x00, 0xFF,
                0xFF, 0xFF, 0xFF, 0x48, 0xC7, 0x40, 0x08, 0xFF, 0xFF, 0xFF, 0xFF, 0xE9, 0x8C, 0x00, 0x00, 0x00,
            ],
            off: [
                0x4C, 0x8D, 0x05, 0xD9, 0x6C, 0x31, 0x00, 0x48, 0x8B, 0x94, 0x24, 0xA8, 0x04, 0x00, 0x00, 0x48,
                0x8B, 0x4C, 0x24, 0x38, 0xFF, 0x15, 0x7E, 0x0B, 0x1A, 0x00, 0x48, 0x89, 0x44, 0x24, 0x48, 0x48,
            ]
        }],
    },
    {
        name: '-',
        type: 'splitter',
    },
    {
        name: "去除歌曲数量限制",
        patches: [{
            offset: 0x897AC6, off: [0x7F, 0x19], on: [0x90, 0x90],
        }],
    },
    {
        name: "Omnimix 补丁",
        tooltip: "推荐使用 <a href=\"https://github.com/mon/ifs_layeredfs\">IFS Layered FS</a> 方式安装, 不再提供此补丁",
        type: "tooltip",
    },
] as Patch[];
